import type { ComponentPropsWithRef } from 'react';
import type React from 'react';

import { InfoIcon, InfoV2Icon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';

import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';

import { useInfoTooltip } from './hooks/useInfoTooltip';

export const InfoTooltip: React.FC<
	ComponentPropsWithRef<'button'> & { size?: number; onTooltipClose?: () => void }
> = ({ children, ref, size = 18, onClick, onTooltipClose, ...props }) => {
	const { translate } = useI18n();
	const { data, actions } = useInfoTooltip();
	const Icon = data.isOpen ? InfoIcon : InfoV2Icon;

	const handleOpenChange = (open: boolean) => {
		actions.setIsOpen(open);
		if (!open) onTooltipClose?.();
	};

	return (
		<Tooltip open={data.isOpen} onOpenChange={handleOpenChange}>
			<TooltipTrigger
				aria-label={translate('corgi.components.tooltips.info_tooltip.a11y.label')}
				aria-expanded={data.isOpen}
				onClick={(e) => {
					actions.toggleTooltip();
					onClick?.(e);
				}}
				{...props}
			>
				<Icon size={size} className="m-1" />
			</TooltipTrigger>
			<TooltipContent data-qa="tooltip-help-text" className="z-[5001]">
				{children}
			</TooltipContent>
		</Tooltip>
	);
};
